// extracted by mini-css-extract-plugin
export default {"aboutBanner":"AboutBanner_aboutBanner__FRuF4"};